/**
 * Quarter and Cycle (interval) API Endpoints
 */

export const INTERVAL_QUARTER_ENDPOINTS = {
  list: 'interval/get-quarter',
  create: 'interval/create-quarter',
  update: 'interval/update-quarter',
} as const;

export const INTERVAL_CYCLE_ENDPOINTS = {
  list: 'interval/get-cycle',
  create: 'interval/create-cycle',
  update: 'interval/update-cycle',
} as const;
